import React, { Component } from "react";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowRight} from "@fortawesome/free-solid-svg-icons";
export default class CardEmpresa extends Component {

  constructor(props) {
    super(props);

    let imgEmpresa = JSON.parse(sessionStorage.getItem("imgEmpresas"))
      .find(img => img.idEmpresa === this.props.empresa.idEmpresa);


    this.state = {
      itemSelected: props.itemSelected,
      img: props.img,
      label: props.label,
      codigo: props.codigo,
      valorSeleccionado: "",
      logoEmpresa: imgEmpresa && imgEmpresa.logoBase64,
      flyerEmpresa: imgEmpresa && imgEmpresa.flyerBase64
    };

  }


  componentDidMount() { 
  }

  handleChange = (e) => {
    let object = {
      idEmpresa: this.props.empresa.idEmpresa,
      nombreEmpresa: this.props.empresa.nombreEmpresa,
      descripcion: this.props.empresa.descripcion,
      vigencia: this.props.empresa.vigencia,
      imagenFlyer: this.state.flyerEmpresa,
      logoEmpresa: this.state.logoEmpresa,
      direccion: this.props.empresa.direccionConvenio
    }


    let texto = JSON.stringify(object);


    this.props.selectorValue(texto);
  };

  imageOnError = (e) => {
    e.target.src = "./dist/img/logo_default.png";
  }

  render() {

    var { nombreEmpresa, descripcionCorta } = this.props.empresa;
    var { logoEmpresa } = this.state;

    //logoEmpresa = logoEmpresa ? logoEmpresa : "./dist/img/logo_default.png";
    logoEmpresa = logoEmpresa
      ? <img src={logoEmpresa} className="card-img w-100 p-4" alt={nombreEmpresa} onError={(e) => this.imageOnError(e)} />
      : <img src="./dist/img/logo_default.png" className="card-img" alt="" />;

    return (
      <div className="col-lg-3 col-md-6 col-12">
        <div className="card card-empresa-convenio">
          <div className="image m-auto">
            {/* <img src={logoEmpresa} className="card-img w-75 p-4" alt={nombreEmpresa} /> */}
            {logoEmpresa}
          </div>
          <div className="card-body">
            <p className="card-title">{nombreEmpresa}</p>
            <p className="card-text">{descripcionCorta}</p>
          </div>
          <div className="card-footer">
            <button
              className="btn btn-sm btn-cu-primary" style={{width:"100%"}}
              onClick={(e) => { this.handleChange(e) }}
              type="button">Conocé más <FontAwesomeIcon icon= {faArrowRight}  />
             </button>
          </div>
        </div>
      </div>

    )

  }
}


